module.exports = __webpack_public_path__ + "img/Comoros.64dd44df.gif";